import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataProvider } from '../data/data';

@Injectable()
export class FavoriteProvider extends DataProvider<Array<string>> {
  constructor() {
    super("FAVORITES");
  }

  /**
   * Returns favorites from localstorage
   */
  async getFavorites(): Promise<Array<string>>{
    var x = await this.storage.get();
    if(x.available){
      return x.data;
    } else {
      return new Array<string>();
    }
  }

  /**
   * Adds specified product to favorites list.
   * @param id Id of product to be added as favorite
   */
  async addFavorite(id: string) {
    var x = await this.getFavorites();
    x.push(id);
    await this.storage.set(x);
  }

  /**
   * Checks wether a product is marked favorite.
   * @param id Id of product to be checked if is favorite
   */
  async isFavorite(id: string) : Promise<boolean>{
    var x = await this.getFavorites();
    return x.find(x => x == id) != null;
  }

  /**
   * Removes product from favorites list.
   * @param id Id of product to be removed from favorites list
   */
  async removeProduct(id: string) {
    var x = await this.getFavorites();
    x = x.filter(x => x != id);
    await this.storage.set(x);
  }
}



// WEBPACK FOOTER //
// ./src/providers/favorite/favorite.ts